module.exports = __webpack_public_path__ + "static/img/head-pic.3a510af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/head-pic.png
// module id = IHS+
// module chunks = 1